import i18n from '@/i18n';

export default [
  {
    path: '/labels',
    name: 'labels',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'label',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('labels')
    },
    // route level code-splitting
    component: () =>
      import('../../views/labels/Index'),
    children: [
      {
        path: 'new',
        name: 'labels-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'label',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('labels'),
        },
        component: () => import('../../views/labels/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'labels-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'label',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('labels'),
        },
        component: () => import('../../views/labels/Edit.vue'),
      },
    ],
  },
];
